import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SegovPage } from 'src/app/app.routes';

@Component({
  selector: 'app-segov-sigepo-header-section',
  standalone: true,
  imports: [],
  templateUrl: './segov-sigepo-header-section.component.html',
  styleUrl: './segov-sigepo-header-section.component.css'
})
export class SegovSigepoHeaderSectionComponent {
  @Input() Title?:string;
  @Input() RouteStack?: LinkClickable[]

  constructor(private readonly router: Router){}

  public navigateToRoute(route: string){
    this.router.navigate([route]);
  }
}

export interface LinkClickable {
  title: string;
  route: SegovPage
}
